export default "__VITE_ASSET__CEd7QeC9__"